import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { LoginPage } from '@/components/auth/LoginPage';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { TerritoryStats } from '@/components/dashboard/TerritoryStats';
import { PlanCanicule } from '@/components/heatwave/PlanCanicule';
import { RenovationEnergetique } from '@/components/renovation/RenovationEnergetique';
import { SuiviZan } from '@/components/zan/SuiviZan';
import { CadastreSolaire } from '@/components/solar/CadastreSolaire';
import { Comparaison } from '@/components/comparison/Comparaison';
import { IlotsChaleur } from '@/components/heat/IlotsChaleur';
import { PlaceholderPage } from '@/components/common/PlaceholderPage';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

const MapView3D = lazy(() =>
  import('@/components/map/MapView3D').then((m) => ({ default: m.MapView3D }))
);

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/3d"
        element={
          <ProtectedRoute>
            <ErrorBoundary label="Vue 3D">
              <Suspense
                fallback={
                  <div className="flex h-screen items-center justify-center">
                    Chargement 3D…
                  </div>
                }
              >
                <MapView3D />
              </Suspense>
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        {/* index: Tableau de bord (hi-fi dashboard, embeds the analysis map) */}
        <Route index element={<TerritoryStats />} />
        <Route path="compare" element={<Comparaison />} />
        <Route path="heat" element={<IlotsChaleur />} />
        <Route path="solar" element={<CadastreSolaire />} />
        <Route path="zan" element={<SuiviZan />} />
        <Route path="canicule" element={<PlanCanicule />} />
        <Route path="renovation" element={<RenovationEnergetique />} />
        <Route path="*" element={<PlaceholderPage title="Page introuvable (404)" />} />
      </Route>
    </Routes>
  );
}

export default App;
